





































import { Component, Vue } from "vue-property-decorator";
import boxDownloadModal from "@/components/boxDownloadModal/index.vue";
import bannerCom from "./components/bannerCom.vue";
import recommendCom from "./components/recommendCom.vue";
import { gameInfo } from "@/req/homes";
import { basePcList } from "@/components/footer/baseConfig";
@Component({
  components: { bannerCom, recommendCom, boxDownloadModal },
})
export default class Home extends Vue {
  public gameId = 0;
  public gameName = "";
  public detail: any = {};
  public bannerShow = false;
  public bdVid: any = "";
  public basePcData: any = {};
  public boxUrl =
    "https://static.dhsf.996box.com/box/channel_app/996boxV340SetupSigned@6091.exe";
  public isDownload = false;

  public created() {
    this.bdVid = this.$route.query.qhclickid ? this.$route.query.qhclickid : "";
    const arr = basePcList.filter((item) => {
      return (
        this.$route.name == item.name || this.$route.query.isCom == item.id
      );
    });
    this.basePcData = arr[0];
  }

  public mounted() {
    this.gameId = Number(this.$route.query.gameId);
    this.gameName = (this as any).$route.query.gameName;
    this.getList();
    if (this.gameId) {
      this.downFile();
    }
  }

  public async getList() {
    const obj: any = {
      box_game_id: this.gameId,
    };
    const res = await gameInfo(obj);
    if (res.code == 200) {
      if (res.data.game_info.publicity.length == 0) {
        this.bannerShow = false;
      } else {
        this.bannerShow = true;
      }
      this.detail = res.data.game_info;
    }
  }

  // 下载文件，自定义文件名称
  public downFile() {
    if (this.isDownload) {
      this.$Message.info("正在下载中, 请勿走开哦");
    }
    this.isDownload = true;
    let filename = "";
    if (this.gameId) {
      filename = this.gameId
        ? `996boxV340SetupSigned'web2detail,id=${this.gameId}'@6091.exe`
        : "996boxV340SetupSigned@6091.exe";
    }
    if (this.bdVid) {
      const linkUrl = this.boxUrl;
      const pcUrl: any = this.$fn.get360Link(linkUrl, this.bdVid, this.basePcData);
      const arr = pcUrl.split("/");
      if (arr[arr.length - 1].indexOf(".exe") > 0) {
        filename = arr[arr.length - 1];
      }
    }
    this.downFileCustomName(this.boxUrl, filename);
  }
  // 下载文件，自定义文件名称
  public downFileCustomName(url, filename) {
    const $boxDownloadModal: any = this.$refs.boxDownloadModal;
    $boxDownloadModal.show();
    const x = new XMLHttpRequest();
    x.open("GET", url, true);
    x.responseType = "blob";
    x.onload = () => {
      $boxDownloadModal.close();
      this.isDownload = false;
      const hrefUrl = window.URL.createObjectURL(x.response);
      const a = document.createElement("a");
      a.href = hrefUrl;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    };
    x.send();
  }
}
